var map = {
	"./configurations/mock": [
		96178,
		178
	],
	"./controls/mock": [
		32907,
		907
	],
	"./holidays/mock": [
		8157,
		597
	],
	"./locations/mock": [
		17562,
		562
	],
	"./logs/mock": [
		50482,
		482
	],
	"./occupancies/mock": [
		41353,
		353
	],
	"./schedules/mock": [
		22867,
		867
	],
	"./setpoints/mock": [
		36272,
		272
	],
	"./units/mock": [
		7045,
		45
	],
	"./user/mock": [
		37255,
		255
	],
	"./users/mock": [
		84487,
		487
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 60407;
module.exports = webpackAsyncContext;